import React from 'react';
import { Navigate } from 'react-router-dom';

const getAdminUserRole = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') ?? 'null');
    return userData?.user_role ?? null;
  } catch {
    return null;
  }
};

const AdminRoute = ({ children }) => {
  if (getAdminUserRole() !== 1) {
    return <Navigate to="/home/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
